/*!
 *
 * app.js
 *
 */
/*** ./modules **/
// import scroll2hash from 'scroll2hash';
import Linker from 'linker';
import Menu from 'menu';
import smoothScroll from 'smooth-scroll';
// import Rellax from 'rellax';
// import Page2Top from 'page2top';
// import LinkCurrent from 'link-current';
import Tab from 'tab';
// scroll2hash();
function init() {
    Linker();
    smoothScroll({
        ignore: '[data-ignore-link], .huga a'
    });
    var menu = new Menu({
        btn: '#menuBtn',
        container: '#menuContainer'
    });
    Tab('.l-contents');
}
;
// async function initEvents() {
// 	const tabElem = document.querySelector('.top-events__slider');
// 	if (tabElem) {
// 		const { default: TopEvents } = await import(
// 			/* webpackChunkName: "top-events" */ 'top-events'
// 		);
// 		TopEvents('.top-events__slider');
// 	}
// }
// async function initTab() {
// 	const tabElem = document.querySelector('.c-tab');
// 	if (tabElem) {
// 		const { default: Tab } = await import(
// 			/* webpackChunkName: "tab" */ 'tab'
// 		);
// 		Tab('.c-tab')
// 	}
// }
// async function initAccordion() {
// 	const accordionElem = document.querySelector('.p-faq');
// 	if (accordionElem) {
// 		const { default: Accordion } = await import(
// 			/* webpackChunkName: "accordion" */ 'accordion'
// 		);
// 		Accordion('.p-faq', {
// 			containerSelector: '.p-faq__item',
// 			headSelector: '.p-faq__head',
// 			bodySelector: '.p-faq__body'
// 		});
// 	}
// }
document.readyState !== "loading" ? init() : document.addEventListener("DOMContentLoaded", init);
